//  import { useState } from 'react';
//   import { getApiBaseUrl, getAuthorizationToken } from '../api-helper';
//   import { CosyflowPicker } from '../components/CosyflowPicker';
//   import { CreateTemplateWizard } from '../components/CreateTemplateWizard';
//   import axios from 'axios';
//   import { useAccountContext } from '../context/AccountContext';
//   import Swal from 'sweetalert2';

  export default function DevPage() {
    return (
        <div>
            <p>Hello</p>
        </div>
    )
    //   const [isWizardOpen, setIsWizardOpen] = useState(false);
    //   const [preSelectedCosyflow, setPreSelectedCosyflow] = useState(null);
    //   const accountContext = useAccountContext();

    //   // When user clicks a cosyflow card, open the wizard with that cosyflow pre-selected
    //   const handleCosyflowSelect = (cosyflow) => {
    //       console.log('Selected cosyflow:', cosyflow);
    //       setPreSelectedCosyflow({
    //           uid: cosyflow.uid || String(cosyflow.id),
    //           title: cosyflow.title,
    //           description: cosyflow.description,
    //           category: cosyflow.category,
    //       });
    //       setIsWizardOpen(true);
    //   };

    //   // SweetAlert wrapper for wizard alerts
    //   const showAlert = async (config) => {
    //       const result = await Swal.fire({
    //           title: config.title,
    //           text: config.text,
    //           icon: config.icon,
    //           confirmButtonText: config.confirmButtonText || 'OK',
    //           showCancelButton: config.showCancelButton || false,
    //           cancelButtonText: config.cancelButtonText || 'Cancel',
    //           confirmButtonColor: '#6366f1',
    //           background: '#1a1a2e',
    //           color: '#ffffff',
    //       });
    //       return { isConfirmed: result.isConfirmed };
    //   };

    //   return (
    //       <div className="px-4 relative container mx-auto">
    //           <h2 className="text-xl py-2 font-bold flex flex-row items-center">
    //               <hr className="mr-2 flex-grow border border-white/40 bg-white/40" />
    //               <span>DEV</span>
    //               <hr className="ml-2 flex-grow border border-white/40 bg-white/40" />
    //           </h2>

    //           {/* CosyflowPicker - selecting opens the wizard */}
    //           <CosyflowPicker
    //               fetchCosyflows={async () => {
    //                   const apiInUse = await getApiBaseUrl();
    //                   const response = await axios.get(`${apiInUse}/api/cosyflows/query`, {
    //                       headers: {
    //                           "Content-Type": "application/json",
    //                           "Authorization": `Bearer ${getAuthorizationToken()}`
    //                       }
    //                   });
    //                   return response.data.cosyflows;
    //               }}
    //               onSelect={handleCosyflowSelect}
    //               currentUserAccountNo={accountContext.accountDetails?.accountNo}
    //               showOwnershipFilter={!!accountContext.accountDetails?.accountNo}
    //               title="Create Template from Cosyflow"
    //               subtitle="Select a cosyflow to use as the base for your new template"
    //               ctaText="Use This Cosyflow"
    //           />

    //           {/* CreateTemplateWizard - opens with pre-selected cosyflow */}
    //           <CreateTemplateWizard
    //               isOpen={isWizardOpen}
    //               onClose={() => {
    //                   setIsWizardOpen(false);
    //                   setPreSelectedCosyflow(null);
    //               }}
    //               preSelectedCosyflow={preSelectedCosyflow}
    //               onClearPreSelected={() => setPreSelectedCosyflow(null)}
    //               isLoggedIn={!!accountContext.accountDetails?.accountNo}
    //               accountNo={accountContext.accountDetails?.accountNo}
    //               showAlert={showAlert}

    //               fetchModels={async () => {
    //                   const apiInUse = await getApiBaseUrl();
    //                   const response = await axios.get(`${apiInUse}/api/generate/get-models`);
    //                   // Transform string array to objects with id/title
    //                   const models = response.data.models || [];
    //                   return models.map((model, index) => ({
    //                       id: index,
    //                       title: model,
    //                       name: model,
    //                   }));
    //               }}

    //               fetchModelDefaults={async (model) => {
    //                   const apiInUse = await getApiBaseUrl();
    //                   const response = await axios.get(`${apiInUse}/api/cosyflows/schema?title=${encodeURIComponent(model)}`, {
    //                       headers: { "Authorization": `Bearer ${getAuthorizationToken()}` }
    //                   });
    //                   return {
    //                       defaults: response.data.defaults || {},
    //                       imageFieldNames: response.data.imageFieldNames || [],
    //                       schema: response.data.schema || null,
    //                   };
    //               }}

    //               fetchCosyflow={async (model) => {
    //                   const apiInUse = await getApiBaseUrl();
    //                   const response = await axios.get(`${apiInUse}/api/cosyflows?title=${encodeURIComponent(model)}`, {
    //                       headers: { "Authorization": `Bearer ${getAuthorizationToken()}` }
    //                   });
    //                   return response.data.cosyflow || null;
    //               }}

    //               generateContent={async ({ prompt, basePrompt, model, modelDefaults, imageInputs, onProgress }) => {
    //                   const apiInUse = await getApiBaseUrl();

    //                   // Build params from defaults
    //                   const params = { ...(modelDefaults?.defaults || {}) };

    //                   // Combine prompts
    //                   const finalPrompt = basePrompt ? `${basePrompt}, ${prompt}` : prompt;

    //                   // Find prompt field in schema and set it
    //                   if (modelDefaults?.schema) {
    //                       for (const [key, field] of Object.entries(modelDefaults.schema)) {
    //                           if (field.type === 'prompt') {
    //                               params[key] = finalPrompt;
    //                               break;
    //                           }
    //                       }
    //                   }

    //                   // Add image inputs (strip data URI prefix)
    //                   for (const [fieldName, base64] of Object.entries(imageInputs || {})) {
    //                       params[fieldName] = base64.includes('base64,')
    //                           ? base64.split('base64,')[1]
    //                           : base64;
    //                   }

    //                   // Start generation
    //                   const genResponse = await axios.post(`${apiInUse}/api/generate`, {
    //                       prompt: { ...params, cosyflow: model },
    //                       accountNo: accountContext.accountDetails?.accountNo,
    //                   }, {
    //                       headers: {
    //                           "Content-Type": "application/json",
    //                           "Authorization": `Bearer ${getAuthorizationToken()}`
    //                       }
    //                   });

    //                   const uid = genResponse.data.uid;
    //                   if (!uid) throw new Error(genResponse.data.error || 'Failed to start generation');

    //                   // Poll for progress
    //                   let attempts = 0;
    //                   const maxAttempts = 120;

    //                   while (attempts < maxAttempts) {
    //                       const progressRes = await axios.get(`${apiInUse}/api/generate/progress?uid=${uid}`, {
    //                           headers: { "Authorization": `Bearer ${getAuthorizationToken()}` }
    //                       });
    //                       const data = progressRes.data;

    //                       onProgress?.(data.progress || data.percent || 0);

    //                       // Check for error
    //                       if (data.progress >= 100 && data.error && data.error !== "None") {
    //                           throw new Error(data.error);
    //                       }

    //                       // Check for completion
    //                       if (data.output && data.output.length > 0) {
    //                           const outputUid = data.output[0].uid;
    //                           const outputRes = await axios.get(
    //                               `${apiInUse}/api/generate/output/${uid}/${outputUid}`,
    //                               { headers: { "Authorization": `Bearer ${getAuthorizationToken()}` }}
    //                           );

    //                           return {
    //                               image: outputRes.data.image || outputRes.data.url,
    //                               serverUrl: outputRes.data.url,
    //                               type: 'image',
    //                           };
    //                       }

    //                       await new Promise(r => setTimeout(r, 1000));
    //                       attempts++;
    //                   }

    //                   throw new Error('Generation timed out');
    //               }}

    //               createTemplate={async ({ formData, cosyflowDefinition, accountNo }) => {
    //                   const apiInUse = await getApiBaseUrl();
    //                   const response = await axios.post(`${apiInUse}/api/cosyflows/create`, {
    //                       accountNo,
    //                       title: formData.title,
    //                       description: formData.description,
    //                       category: formData.category,
    //                       baseCosyflow: cosyflowDefinition,
    //                       basePrompt: formData.basePrompt,
    //                       exampleUrls: formData.galleryItems.map(item => item.serverUrl).filter(Boolean),
    //                   }, {
    //                       headers: { "Authorization": `Bearer ${getAuthorizationToken()}` }
    //                   });

    //                   if (response.data.error) {
    //                       return { error: response.data.error };
    //                   }
    //                   return { id: response.data.uid || response.data.id };
    //               }}

    //               onSuccess={(templateId) => console.log('Template created:', templateId)}
    //               onNavigateToTemplate={(templateId) => {
    //                   // Navigate to the new template
    //                   window.location.href = `/template/${templateId}`;
    //               }}
    //           />
    //       </div>
//       );
  }